import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiGet } from "../../../services/apiServices";
import { endPoints } from "../../../configs/apiUrls";
import { FilterType, paginationType } from "./slice";

interface ProprtyTypeListResponse {
    filterData: FilterType;
    success: boolean;
    page: number;
    limit: number;
    total: number;
    totalPages: number;
    data: paginationType[];
}

interface FetchPropertyTypeListParams {
    page?: number;
    limit?: number;
    search?: string;
    sortBy?: string | null;
    sortOrder?: "asc" | "desc" | null;
}

// Main Thunk
export const fetchPropertyTypeList = createAsyncThunk<ProprtyTypeListResponse, FetchPropertyTypeListParams>(
    "area/fetchPropertyTypeList",
    async (
        {
            page = 1,
            limit = 10,
            search = "",
            sortBy = null,
            sortOrder = null,
        },
        thunkAPI
    ) => {
        try {
            // Only include isActive if a boolean was provided, NOT null
            const params = {
                page,
                limit,
                search: search || undefined,
                sortBy: sortBy || undefined,
                sortOrder: sortOrder || undefined,
            };
            const response = await apiGet(endPoints.PROPERTY_TYPE, params);

            return {
                data: response.data,
                filterData: {
                    search,
                    page: response.page,
                    limit: response.limit,
                    totalCount: response.total,
                    sortBy,
                    sortOrder,
                },
                success: response.success,
                page: response.page,
                limit: response.limit,
                total: response.total,
                totalPages: response.totalPages,
            };
        } catch (error) {
            return thunkAPI.rejectWithValue("Failed to fetch area list");
        }
    }
);
